import { Suspense, useEffect, useState } from 'react';
import { getCurrentScreen } from '@auth0/auth0-acul-js';
import { Card, SectionErrorPlaceholder } from '@page/ui';

import { getScreenComponent } from './screens';
import { AuthLayout } from './components/AuthLayout';

const App = () => {
  const [screen, setScreen] = useState('signup-id');

  useEffect(() => {
    const current = getCurrentScreen();
    setScreen(current || 'signup-id');
  }, []);

  const ScreenComponent = getScreenComponent(screen);

  // console.log({ screen });

  return (
    <Suspense fallback={null}>
      {ScreenComponent ? (
        <ScreenComponent />
      ) : (
        <AuthLayout>
          <Card>
            <SectionErrorPlaceholder
              title="Screen not available"
              description="This screen is not implemented yet."
              action="Go back"
              onActionClick={() => {
                window.history.back();
              }}
            />
          </Card>
        </AuthLayout>
      )}
    </Suspense>
  );
};

export default App;
